unable to read source [project]/repos/src/scraping/targets/top-targets.ts